import React from 'react';


// shallow mixin
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }
  var key;
  // Test for A's keys different from B.
  for (key in objA) {
    if (objA.hasOwnProperty(key) &&
        (!objB.hasOwnProperty(key) || objA[key] !== objB[key])) {
      return false;
    }
  }
  // Test for B's keys missing from A.
  for (key in objB) {
    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}

export default class Delegate extends React.Component {

  constructor (props) {
    super(props);
    this.getContainer = this.getContainer.bind(this);
  }

  shouldComponentUpdate (nextProps, nextState) {
    return !shallowEqual(this.props, nextProps) ||
           !shallowEqual(this.state, nextState);
  }

  componentDidMount () {
    this.create(this.getContainer(), this.props);
  }

  componentDidUpdate () {
    this.update(this.getContainer(), this.props);
  }

  componentWillUnmount () {
    this.destroy(this.getContainer(), this.props);
  }

  render () {
    return <div ref="container" className={this.props.className}></div>;
  }

  getContainer () {
      return this.refs.container;
  }

}

